import { render, staticRenderFns } from "./TemplateFilial.vue?vue&type=template&id=2097c340&"
import script from "./TemplateFilial.vue?vue&type=script&lang=js&"
export * from "./TemplateFilial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports